import { Button, Form } from "antd";
import { useState } from "react";
import { CgCloseR } from "react-icons/cg";
import FilterBodyForm from "./FilterBodyForm";

type Props = {
  setIsFilter?: any;
  filterType: any;
  setOpen: any;
};

const FilterForm = ({ setIsFilter, filterType, setOpen }: Props) => {
  const [form] = Form.useForm();
  const [filledCount, setFilledCount] = useState(0);

  const onFinish = (values: any) => {
    console.log(values);
    setIsFilter(values);
    setOpen(false);
  };
  const clearForm = () => {
    form.resetFields(); // This will clear all the fields in the form
    setFilledCount(0);
  };
  const onValuesChange = (_: any, allValues: any) => {
    let totalWordCount = 0;

    const calculateWordCount = (value: any) => {
      if (typeof value === "string") {
        totalWordCount += value.trim().split(/\s+/).filter(Boolean).length;
      } else if (Array.isArray(value)) {
        value.forEach((item) => calculateWordCount(item)); // Handle arrays, e.g., lists of tags or keywords
      } else if (typeof value === "object" && value !== null) {
        Object.values(value).forEach((innerValue) =>
          calculateWordCount(innerValue)
        ); // Recurse for nested objects
      }
    };
    Object.values(allValues).forEach((value) => calculateWordCount(value));
    console.log("Total word count of all form values:", totalWordCount);
    setFilledCount(totalWordCount); // Assuming setFilledCount updates your state
  };
  return (
    <Form
      className="w-full rounded-lg"
      name="filterTableAdmin"
      onFinish={onFinish}
      layout={"vertical"}
      onValuesChange={onValuesChange}
      form={form}
      initialValues={{
        name: {
          ar: "",
          en: "",
        },
      }}
    >
      <div className="px-4 py-6 grid gap-6 items-center min-w-[480px]">
        <div
          onClick={() => clearForm()}
          className="flex items-center gap-1 text-xs text-[#4F5062] bg-[#EEF0FF] py-1 px-2 rounded-lg w-fit cursor-pointer"
        >
          <span>selected</span>
          <span>
            (<span className="text-black">{filledCount}</span>)
          </span>
          <CgCloseR className="flex items-center text-[#C43535]" />
        </div>
        <FilterBodyForm {...filterType} />
        <Button htmlType="submit" type="primary" className="w-full">
          Confrim
        </Button>
      </div>
    </Form>
  );
};

export default FilterForm;
